import { i18n } from '@/localization';
import { LabelFormat, Translate, TranslateValue } from '../interfaces/translation';
import { capitalizeWords } from '@shared/utils/string';
import { capitalize } from 'lodash';
import { feature } from '@libs/utils/feature/feature';

export function t({
    key,
    keyPlural,
    count = 1,
    values = [],
    suffix = '',
    prefix = '',
    format = LabelFormat.Default,
}: Translate): string {
    const keyToUse = keyPlural && count > 1 ? keyPlural : key;
    const htmlValues = values.map(wrapBold);
    const label = i18n.global.t(keyToUse, htmlValues);

    if (feature('translation-key')) {
        return keyToUse;
    }

    if (keyToUse === label) {
        return '';
    }

    return `${prefix}${formatLabel(label, format)}${suffix}`;
}

function formatLabel(label: string, format: LabelFormat) {
    switch (format) {
        case LabelFormat.LowerCase:
            return label.toLowerCase();
        case LabelFormat.UpperCase:
            return label.toUpperCase();
        case LabelFormat.Capitalize:
            return capitalize(label);
        case LabelFormat.CapitalizeWords:
            return capitalizeWords(label);
        default:
            return label;
    }
}

function wrapBold(v: TranslateValue): string {
    if (v == null) return '';
    if (typeof v === 'object') {
        const txt = String(v.value);
        return v.bold ? `<strong>${txt}</strong>` : txt;
    }
    return String(v);
}
